export const calculateProfitability = (formData) => {
  // Parse all numeric inputs with fallback to 0
  const parseValue = (value) => parseFloat(value) || 0;

  // Fixed Costs
  const employeeCosts = parseValue(formData.employeeCosts);
  const materials = parseValue(formData.materials);
  const subcontractors = parseValue(formData.subcontractors);
  const otherFixedCosts = parseValue(formData.otherFixedCosts);
  const fixedCostsSubtotal = employeeCosts + materials + subcontractors + otherFixedCosts;

  // Variable Costs
  const consultantHours = parseValue(formData.consultantHours);
  const hourlyRate = parseValue(formData.hourlyRate);
  const consultantTime = consultantHours * hourlyRate;
  const projectAdmin = parseValue(formData.projectAdmin);
  const otherVariableCosts = parseValue(formData.otherVariableCosts);
  const variableCostsSubtotal = consultantTime + projectAdmin + otherVariableCosts;

  // Other inputs
  let packagePrice = parseValue(formData.packagePrice);
  const contingencyBuffer = parseValue(formData.contingencyBuffer) / 100;
  const incomeTaxRate = parseValue(formData.incomeTaxRate) / 100;
  
  // Handle referral fee calculation
  const referralFeeType = formData.referralFeeType || 'amount';
  const referralFeeValue = parseValue(formData.referralFeeValue);
  let referralFee = 0;
  
  if (referralFeeValue > 0) {
    if (referralFeeType === 'percentage') {
      referralFee = packagePrice * (referralFeeValue / 100);
    } else {
      referralFee = referralFeeValue;
    }
  }
  
  // Adjust package price after referral fee
  const adjustedPackagePrice = packagePrice - referralFee;

  // Calculations following the specified logic
  const hardCosts = fixedCostsSubtotal + variableCostsSubtotal;
  const contingency = contingencyBuffer * hardCosts;
  const totalDeliveryCosts = hardCosts + contingency;
  
  // Extract GST from package price (assuming package price is GST-inclusive)
  // Formula: GST = (Price × GST rate) ÷ (1 + GST rate)
  const gstRate = 0.1; // 10% GST
  const gst = (adjustedPackagePrice * gstRate) / (1 + gstRate);
  
  const netRevenue = adjustedPackagePrice - gst;
  const grossProfit = netRevenue - totalDeliveryCosts;
  const estimatedTax = Math.max(0, incomeTaxRate * grossProfit); // Don't tax negative profits
  const afterTaxProfit = grossProfit - estimatedTax;
  const margin = netRevenue > 0 ? (grossProfit / netRevenue) * 100 : 0;

  return {
    fixedCostsSubtotal,
    variableCostsSubtotal,
    hardCosts,
    contingency,
    totalDeliveryCosts,
    gst,
    netRevenue,
    grossProfit,
    estimatedTax,
    afterTaxProfit,
    margin,
    referralFee,
    adjustedPackagePrice
  };
};